import React, { useEffect } from 'react'
import { Page, Image, Typography } from 'components/common'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'
import Navigation from '../components/Navigation'
import errorIconSVG from 'assets/images/tw-icon-error.svg'
import theme from 'theme'
import { useTranslation } from 'react-i18next'
import { useProductUiEvent } from 'hooks/useEvents'
import useStore from 'hooks/useStore'

const ErrorPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const eventManager = useProductUiEvent()
    const [store] = useStore()
    const tselWalletData = store?.tselWalletData

    const handleBack = () => {
        if (location.pathname !== '/user/dashboard') {
            navigate(-1)
        } else {
            window.location.href = (
                tselWalletData?.callback_url
                    ? tselWalletData.callback_url
                    : process.env.REACT_APP_TELKOMSEL_WALLET_CALLBACK_URL
            ) as string
        }
    }

    useEffect(() => {
        eventManager.trackPage('TSEL_WALLET_ERROR_PAGE', {
            payment: {
                type: 'TELKOMSEL_WALLET',
            },
            requestId: store?.requestId,
            useTimestamp: true,
        })
    }, [])

    return (
        <Page background="bg-gray-300">
            <Page.Container
                className="bg-gray-300"
                data-testid="error-page"
                style={{ height: '100vh' }}
            >
                <Container>
                    <Navigation
                        title="Telkomsel Wallet"
                        isPrimary={false}
                        showLeftIcon={true}
                        showRightIcon={false}
                        onClickLeftIcon={handleBack}
                    />
                    <ErrorContent>
                        <Image
                            src={errorIconSVG}
                            height="128px"
                            width="128px"
                            className="mb-[32px]"
                        />
                        <Typography.Title className="font-semibold text-[16px]">
                            {t('tselWallet.pages.errors.title')}
                        </Typography.Title>
                        <Typography.Label
                            variant="s"
                            style={{
                                color: theme?.TSEL?.color?.text?.secondary,
                                marginTop: '4px',
                                width: '290px',
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '22px',
                            }}
                        >
                            {t('tselWallet.pages.errors.description')}
                        </Typography.Label>
                    </ErrorContent>
                </Container>
            </Page.Container>
        </Page>
    )
}

export default ErrorPage

export const Container = styled.div`
    position: relative;
    margin-bottom: 24px;
`

export const ErrorContent = styled.div`
    position: relative;
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: ${({ theme }) => theme.TSEL.color.light};
    margin: 20px;
    border-radius: 16px;
    text-align: center;
    min-height: calc(100vh - 120px);
    padding: 20px;
`
